const styles = theme => ({
  title: {
    fontWeight: 600,
    marginBottom: '5px',
  },
  link: {
    textDecoration: 'none',
  },
  transactionsNotification: {
    textAlign: 'center',
    padding: '20px',
    marginTop: '100px',
    '& $tcTextHolder': {
      maxWidth: '300px',
      margin: '0 auto',
      '& $title': {
        marginBottom: '8px',
        fontSize: '14px',
      },
      '& p': {
        color: '#8C9099',
        fontSize: '12px',
      },
    },
  },
  tcTextHolder: {},
  infoMessageTooltip: {
    background: '#EBF7FF',
    color: '#342D3D',
    borderRadius: '0px',
    border: '1px solid #0496FF',
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    minHeight: '44px',
    padding: '12px 22px',
    marginBottom: '25px',
    '& img': {
      marginRight: '8px',
    },
    '& strong': {
      fontWeight: '600',
      color: '#1270B4',
      marginLeft: '3px',
    },
  },
  btnADGMred: {
    background: theme.palette.primary.main,
    fontSize: '16px',
    color: '#fff',
    height: '36px',
    minWidth: '213px',
    textTransform: 'none',
    borderRadius: '0px',
    marginTop: '15px',
    fontWeight: '600',
    '&:hover': {
      background: theme.palette.primary.main,
    },
  },
  '@media (min-width:600px)': {
    transactionsNotification: {
      '& $tcTextHolder': {
        '& $title': {
          fontSize: '16px',
        },
        '& p': {
          fontSize: '14px',
        },
      },
    },
  },
});

export default styles;
